module.exports = __webpack_public_path__ + "static/media/cancer-symptoms-trials-news.fd68865e.jpg";